const tabs = document.querySelectorAll(".tab")
const tabContents = document.querySelectorAll(".tab-content")

document.addEventListener("click", e => {
  if (e.target.matches(".tab")) {
    let selectedTab = e.target.dataset.tab

    /* Clear Tab Active Class */
    tabs.forEach(tab => {
      tab.classList.remove("tab-active")
      tab.setAttribute("aria-selected", "false")
    })

    /* Clear Tab Content Active Class */
    tabContents.forEach(tabContent => {
      tabContent.classList.remove("tab-content-active")
      tabContent.setAttribute("aria-hidden", "true")
    })

    /* Find Selected Tab's Content */
    const tabContentsArray = [...tabContents]
    let selectedTabContent = tabContentsArray.find(
      tabContent => tabContent.dataset.tabContent == selectedTab
    )

    /* Add Classes to Active Elements */
    e.target.classList.add("tab-active")
    e.target.setAttribute("aria-selected", "true")
    selectedTabContent.classList.add("tab-content-active")
    selectedTabContent.setAttribute("aria-hidden", "false")
  }
})
